import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=4b135ef2&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=ts"
export * from "./Pagination.vue?vue&type=script&lang=ts"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=4b135ef2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b135ef2",
  null
  
)

export default component.exports